export function Quote({ color = 'currentColor', className = '', ...props }) {
    return (
        <svg
            width="1em"
            height="1em"
            className={className}
            {...props}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.17857 18L7.71428 18L10.0714 13.2L10.0714 6L3 6L3 13.2L6.53571 13.2L4.17857 18ZM13.6071 18L17.1429 18L19.5 13.2L19.5 6L12.4286 6L12.4286 13.2L15.9643 13.2L13.6071 18Z"
            />
        </svg>
    )
}
